import { UserMetadata, UserMetadataFlags, UserMetadataGetPayload } from 'pages/Dashboard/types';
import {
  AssociateProviderPayload,
  PracticeProvidersListResponse,
  ProviderDesgination,
  ProviderDetailsResponse,
} from 'pages/Dashboard/types/providers.types';
import { QueryFunctionContext } from 'react-query';
import { providers } from 'utils/apiUrls';
import { HttpType } from 'utils/http';

export const fetchPracticeProvidersList = (
  method: HttpType['get'],
  practiceId: string,
  designations?: ProviderDesgination[],
) => function async({ queryKey }: QueryFunctionContext): Promise<PracticeProvidersListResponse> {
  return method(
    providers.practiceProvidersList.apiUrl(
      practiceId as string,
      designations?.length ? designations.toString() : '',
    ),
  );
};

export const fetchUserMetadata = (method: HttpType['post'], payload: UserMetadataGetPayload) => function async(): Promise<UserMetadata> {
  return method(providers.metadata.apiUrl(), payload);
};

export const fetchUserMetadataWithKeys = (method: HttpType['post']) => function async({ queryKey }: QueryFunctionContext): Promise<UserMetadata> {
  const [providerId, flag] = queryKey;
  const payload: UserMetadataGetPayload = {
    userId: providerId as string,
    name: flag as UserMetadataFlags,
  };
  return method(providers.metadata.apiUrl(), payload);
};

export const postUserMetadata = (method: HttpType['post'], payload: UserMetadata) => method(providers.postMetadata.apiUrl(), payload);

export const fetchProvidersAssociationsList = (method: HttpType['get']) => function async({ queryKey }: QueryFunctionContext): Promise<PracticeProvidersListResponse> {
  const [, providerId] = queryKey;

  return method(providers.providerAssociationList.apiUrl(providerId as string));
};

export const updateAssociatedProviders = (method: HttpType['post'], { associate, ...rest }: AssociateProviderPayload) => method(providers.associateProviders.apiUrl(associate as boolean), rest);

export const resendProviderActivationEmail = (method: HttpType['post'], providerId: string) => method(providers.resendActivationEmail.apiUrl(providerId as string), {});

export const updateEmailAndResendProviderActivationEmail = (method: HttpType['patch'], providerId: string, email: string) => method(providers.updateEmailAndResendActionEmail.apiUrl(providerId as string), { new_email: email });

export const fetchProviderDetails = (method: HttpType['get']) => function async({ queryKey }: QueryFunctionContext): Promise<ProviderDetailsResponse> {
  const [, providerId] = queryKey;
  return method(providers.providerDetails.apiUrl(providerId as string));
};
